<template>
	<div>
		<StepOne @nextStep="nextStep()" v-if="step === 1" />
		<StepTwo @nextStep="nextStep()" @submitProcess="submitProcess" v-if="step === 2" />
		<StepThree :result="result" v-if="step === 3" />
	</div>
</template>
<script>
import StepOne from './steps/StepOne.vue'
import StepTwo from './steps/StepTwo.vue'
import StepThree from './steps/StepThree.vue'
export default {
	name: 'SolicitacaoCessaoDireitos',
	components: {
		StepOne,
		StepTwo,
		StepThree,
	},

	data() {
		return {
			step: 1,
			lastStep: 3,
			result: null,
		}
	},

	methods: {
		nextStep() {
			if (this.step < this.lastStep) {
				this.step++
			}
		},

		submitProcess(value) {
			this.result = value
			this.nextStep()
		},
	},
}
</script>
